import { setCurrentGroup as setCurrentGroupInit } from '@gmini/common/lib/classifier-editor/ClassifierTree/model/groupModel'

export const setCurrentGroup = setCurrentGroupInit
